import {
  FieldError as AriaFieldError,
  type FieldErrorProps as AriaFieldErrorProps,
} from 'react-aria-components';
import clsx from 'clsx';

/** React Aria `FieldError`; renders only while the field is invalid and joins `aria-describedby`. */
export function FieldError({
  className,
  ...rest
}: Omit<AriaFieldErrorProps, 'className'> & { className?: string }) {
  const classes = clsx(
    // The error token passes 4.5:1 on base-100 and base-200, and is the invalid
    // border's colour too. The mark keeps an error from being colour-only.
    "text-sm text-error before:mr-1 before:content-['⚠']",
    className,
  );
  return <AriaFieldError {...rest} className={classes} />;
}
